import { useMemo } from 'react';
import { PULSE_EMPTY_STATES } from '../../pulse.common';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import { useSelector } from 'react-redux';
import { teamPmEntitiesIdsSelector } from 'state/selectors/projects';
import { isEmpty } from 'lodash';
import { PROJECT_STATUS } from '@linearb/linjs-common';

const useEmptyStateType = ({
  isEnabled,
  isLoading,
  selectedTab,
  selectedTeam,
  pdtStatus,
  pdtIterations
}) => {
  const pmProvider = usePmProvider();
  const teamPMEntitiesIds = useSelector(state =>
    teamPmEntitiesIdsSelector(state, selectedTeam?.id)
  );

  const emptyState = useMemo(() => {
    if (!isEnabled || isLoading) return null;

    if (!pmProvider) return PULSE_EMPTY_STATES.NO_PM_CONNECTED;

    if (!selectedTeam) return PULSE_EMPTY_STATES.NO_TEAM_SELECTED;

    if (isEmpty(teamPMEntitiesIds)) return PULSE_EMPTY_STATES.UNCONFIGURED_TEAM;

    if (pdtStatus !== PROJECT_STATUS.STEADY || !pdtIterations.length)
      return PULSE_EMPTY_STATES.LOADING_PAST_ITERATIONS;

    return null;
  }, [
    isEnabled,
    isLoading,
    pmProvider,
    selectedTab,
    selectedTeam,
    teamPMEntitiesIds,
    pdtStatus,
    pdtIterations
  ]);

  return emptyState;
};

export default useEmptyStateType;
